import { CarburetionPage } from "../views/Carburetion/CarburetionPage";
import { CARBURETION_ACTIONS } from "redux/reducers/carburetions/actions";
import LocalGasStationIcon from "@material-ui/icons/LocalGasStation";

const CarburetionErrorConf = {
  reducer: "carburations",
  restoreKey: CARBURETION_ACTIONS.RESTORE_INITIAL
}


export const carburetionRoutes = [
    {
      collapse: true,
      name: "Carburaciones",
      icon: LocalGasStationIcon,
      state: "carburetionSection",
      inSidebar: true,
      isProtected: true,
      rule: "CARBURETIONS",
      views: [
        {
          path: "/Carburacion",
          name: "Carburación",
          mini: "CB",
          component: CarburetionPage,
          layout: "/admin",
          inSidebar: true,
          isProtected: true,
          rule: "CARBURETIONS",
          ...CarburetionErrorConf,
        },
      ],
    },
]